import { z } from 'zod';
import { idSchema, timestampsSchema } from './common';

/** The default visible 11-stage pipeline executed per role-agent run. */
export const runStageNames = [
  'Lobby',
  'Ingest',
  'Triage',
  'Plan',
  'Hierarchy',
  'Execute',
  'Post-Exec',
  'Review',
  'Publish',
  'Learn',
  'Done',
] as const;
export const runStageNameSchema = z.enum(runStageNames);
export type RunStageName = z.infer<typeof runStageNameSchema>;

/** Default flow; stage sets are intended to be configurable per workflow type. */
export const defaultStageFlow: RunStageName[] = [...runStageNames];

export const stageStatuses = ['pending', 'active', 'done', 'skipped', 'cancelled'] as const;
export const stageStatusSchema = z.enum(stageStatuses);
export type StageStatus = z.infer<typeof stageStatusSchema>;

export const runStageSchema = z
  .object({
    id: idSchema,
    tenantId: idSchema,
    runId: idSchema,
    stage: runStageNameSchema,
    status: stageStatusSchema.default('pending'),
    seq: z.number().int().nonnegative().default(0),
    startedAt: z.coerce.date().nullish(),
    endedAt: z.coerce.date().nullish(),
    elapsedMs: z.number().int().nonnegative().default(0),
    tokens: z.number().int().nonnegative().default(0),
    detail: z.record(z.unknown()).default({}),
  })
  .merge(timestampsSchema.partial());
export type RunStageRecord = z.infer<typeof runStageSchema>;

/** Live status snapshot returned by the Temporal RUN_STATUS_QUERY. */
export interface RunStatusSnapshot {
  currentStage: RunStageName;
  stages: { stage: RunStageName; status: StageStatus }[];
}
